<template>
    <section>
        <div class="container">       
            <CommonBreadcrumb class="bread_block_mod" /> 
        </div>
   
        <div class="container-fluid px-0">
            <div class="guide_block_banner">
                <div class="eng_guide_banner">
                    <picture v-if="$country.is_india">
                        <source width="1920" height="540" type="image/webp" srcset="~/assets/eng-guide/step_five/india/banner.webp">
                        <img height="540" width="1920" src="~/assets/eng-guide/step_five/india/banner.jpg" alt="time to propose">
                    </picture>
                    <picture v-else>
                        <source width="1920" height="540" type="image/webp" srcset="~/assets/eng-guide/step_five/banner.webp">
                        <img height="540" width="1920" src="~/assets/eng-guide/step_five/banner.jpg" alt="time to propose">
                    </picture>
                    <div class="eng_guide_upper">
                        <h2>what are you waiting for?</h2>
                        <h1 class="font-active">time to propose</h1>
                        <div class="eng_guide_flex my-3">
                            <NuxtLink href="/ring-settings" class="me-2 radious_four">Start with Setting</NuxtLink>
                            <NuxtLink href="/lab-diamond-rings" class="radious_four">Start with Diamond</NuxtLink>
                        </div>
                        <p class="mb-0" v-if="$country.is_india">
                            Deciding whether to plan a simple or extravagant proposal or somewhere in between is a lot of pressure, but there are a few ways to ensure that you're planning the best possible proposal for your partner. It can also be complicated, especially with thousands of proposal ideas floating around the internet. But you don't have to worry, because we've got your back!
                        </p>
                        <p class="mb-0" v-else>Deciding whether to plan a simple or extravagant proposal or somewhere in between is a lot of pressure, but there are a few ways to ensure that you're planning the best possible proposal for your partner. It can also be complicated, especially with thousands of proposal ideas floating around the internet. But you don't have to worry, because we've got your back!</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="container">
            <div class="row align-items-center py-4 guide_block">
                <div class="col-md-6 col-12">
                    <picture>
                        <source width="577" height="364" type="image/webp" srcset="~/assets/eng-guide/step_five/romantic.webp">
                        <img loading="lazy" class="radious_eight" width="577" height="364" type="image/jpeg" src="~/assets/eng-guide/step_five/romantic.jpg" alt="romantic gateway">
                    </picture>
                </div>
                <div class="col-md-6 col-12">
                    <h2 class="mb-0 font-active">romantic gateway</h2>
                    <p v-if="$country.is_india" class="my-4">
                        A picnic may be one of the best romantic proposal ideas if you plan it perfectly. It allows you to include your partner's family and friends. Place candles, a good bottle of wine, chocolate-covered berries or whatever your partner's favorite is in a basket, your proposal ring, and you're ready to go. You can choose destinations like the Cayman Islands, Bora Bora Mountains, Maldives, or Northern Italy.
                        <br><br>
                        Thomas gave the best surprise to Kristen with a <NuxtLink :to="localePath({ name:'cyo-diamond-list-ring'})">dream ring</NuxtLink> at a dream destination.
                    </p>
                    <p class="my-4" v-else>
                        A picnic may be one of the best romantic proposal ideas if you plan it perfectly. It allows you to include your partner's family and friends. Place candles, a good bottle of wine, chocolate-covered berries, or whatever your partner's favorite is in a basket, <NuxtLink :to="localePath('/blog/types-of-proposal-rings-for-her')">your proposal ring,</NuxtLink> and you're ready to go. You can choose destinations like the Cayman Islands, Bora Bora Mountains, Maldives, or Northern Italy.
                        <br><br>
                        Thomas gave the best surprise to Kristen with a dream ring at a dream destination.
                    </p>
                    <h3 class="mb-4">Thomas Watson & Kristen</h3>
                    <NuxtLink class="radious_four" :to="localePath('/testimonials/thomas-kristen')">Read more</NuxtLink>
                </div>
            </div>
            
            <div class="row align-items-center py-4 guide_block row_mod">
                <div class="col-md-6 col-12">
                    <h2 class="mb-0 font-active">their hometown</h2>
                    <p class="my-4" v-if="$country.is_india">
                        Proposing at your hometown in the presence of your friends and family is one of the popular proposal ideas for a reason: It's memorable and scenic, provides you with a pleasant vibe and distracts you from jitters before you pop the million-dollar question. You can choose a lakeside location or any location that gives a stunning view of nature.
                        <br><br>
                        Kevin popped the question to Monica in the most romantic way in their hometown.
                    </p>
                    <p class="my-4" v-else>
                        Proposing at your hometown in the attendance of your friends and family is one of the popular <NuxtLink :to="localePath('/blog/marriage-proposal-ideas')">proposal ideas</NuxtLink> for a reason: It's memorable and scenic, provides you with a pleasant vibe, and distracts you from jitters before you pop the million-dollar question. You can choose a lakeside location or any location that gives a stunning view of nature. <br><br>
                        Kevin popped the question to Monica in the most romantic way in their hometown.
                    </p>
                    <h3 class="mb-4">Kevin Fulmer & Monica</h3>
                    <NuxtLink class="radious_four" :to="localePath('/testimonials/kevin-monica')">Read more</NuxtLink>
                </div>
                <div class="col-md-6 col-12">
                    <picture>
                        <source width="577" height="364" type="image/webp" srcset="~/assets/eng-guide/step_five/hometown.webp">
                        <img loading="lazy" width="577" height="364" class="radious_eight" type="image/jpeg" src="~/assets/eng-guide/step_five/hometown.jpg" alt="their hometown">
                    </picture>
                </div>
            </div>

            <div class="row align-items-center py-4 guide_block">
                <div class="col-md-6 col-12">
                    <picture>
                        <source width="577" height="364" type="image/webp" srcset="~/assets/eng-guide/step_five/candle.webp">
                        <img loading="lazy" width="577" height="364" class="radious_eight" type="image/jpeg" src="~/assets/eng-guide/step_five/candle.jpg" alt="candle light dinner">
                    </picture>
                </div>
                <div class="col-md-6 col-12">
                    <h2 class="mb-0 font-active">candle light dinner </h2>
                    <p class="my-4" v-if="$country.is_india">
                        There is no specific season for a proposal, and you can do it anytime with a proposal ring. So, if it's a rainy day and you don't feel like stepping outdoors, just do it indoors. When you add twinkling lights to the mix, you'll have an incredibly stunning sight that takes practically little preparation from your side and is one of the sweetest proposal ideas ever.
                        <br><br>
                        Ney proposed to Ozge while having a candlelight dinner at this beautiful location.
                    </p>
                    <p v-else class="my-4">There is no specific season for a proposal, and you can do it anytime with a <NuxtLink :to="localePath('/blog/types-of-proposal-rings-for-her')">proposal ring</NuxtLink>. So, if it's a rainy day and you don't feel like stepping outdoors, just do it indoors. When you add twinkling lights to the mix, you'll have an incredibly stunning sight that takes practically little preparation from your side and is one of the sweetest proposal ideas ever. <br><br>
                    Ney proposed to Ozge while having a candlelight dinner at this beautiful location.</p>
                    <h3 class="mb-4">Ney Paredes & Ozge</h3>
                    <NuxtLink class="radious_four" :to="localePath('/testimonials/ney-ozge')">Read more</NuxtLink>
                </div>
            </div>

            <div class="row align-items-center py-4 guide_block row_mod">
                <div class="col-md-6 col-12">
                    <h2 class="mb-0 font-active">where you first said "i love you"</h2>
                    <p class="my-4" v-if="$country.is_india">
                        May it be a neighborhood park or your high school soccer stadium, brighten up these places with gorgeous flowers and decorations while you ask her the question with the most stunning proposal ring. It will be a familiar, comforting place that has been enhanced to seem even more magical. Moreover, you may relive the experience whenever you pass by the site in the future and pat your back to come up with the best proposal idea ever.
                        <br><br>
                        Cody proposed to Stephanie near a beautiful lake, and she said Yes!
                    </p>
                    <p class="my-4" v-else>May it be a neighborhood park or your high school soccer stadium, brighten up these places with gorgeous flowers and decorations while you ask her the question with the most stunning proposal ring. It will be a familiar, comforting place that has been enhanced to seem even more magical. Moreover, you may relive the experience whenever you pass by the site in the future and pat your back to come up with the best proposal idea ever. <br><br>
                    Cody proposed to Stephanie near a beautiful lake, and she said Yes!</p>
                    <h3 class="mb-4">Cody Rosa & Stephanie</h3>
                    <NuxtLink class="radious_four" :to="localePath('/testimonials/cody-stephanie')">Read more</NuxtLink>
                </div>
                <div class="col-md-6 col-12">
                    <picture>
                        <source width="577" height="364" type="image/webp" srcset="~/assets/eng-guide/step_five/first_propose.webp">
                        <img loading="lazy" width="577" height="364" class="img-fluid radious_eight" src="~/assets/eng-guide/step_five/first_propose.jpg" alt="where you first said i love you">
                    </picture>
                </div>
            </div>
            
            <div class="row align-items-center py-4 guide_block">
                <div class="col-md-6 col-12">
                    <picture>
                        <source width="577" height="364" type="image/webp" srcset="~/assets/eng-guide/step_five/outdoors.webp">
                        <img loading="lazy" width="577" height="364" class="img-fluid radious_eight" src="~/assets/eng-guide/step_five/outdoors.jpg" alt="the great outdoors">
                    </picture>
                </div>
                <div class="col-md-6 col-12">
                    <h2 class="mb-0 font-active">the great outdoors</h2>
                    <p class="my-4" v-if="$country.is_india">If you're fortunate enough to have a rooftop (or a friend with a rooftop) with a spectacular view, consider adorning it with floral bouquets or other embellishments. Go to the top to view the sunset, then get down on one knee with a proposal ring you picked for her. It's the most beautiful, personal, adorable and affordable proposal idea.
                        <br><br>
                        Peter proposed to Jenn in the most romantic way picking a dreamy location.
                    </p>
                    <p class="my-4" v-else>If you're fortunate enough to have a rooftop (or a friend with a rooftop) with a spectacular view, consider adorning it with floral bouquets or other embellishments. Go to the top to view the sunset, then get down on one knee with a proposal ring you picked for her. It's the most beautiful, personal, adorable, and affordable proposal idea. <br><br>
                    Peter proposed to Jenn in the most romantic way picking a dreamy location.
                    </p>
                    <h3 class="mb-4">Peter Perez & Jenn Leitner</h3>
                    <NuxtLink class="radious_four" :to="localePath('/testimonials/peter-jenn')">Read more</NuxtLink>
                </div>
            </div>
            
            <div class="row align-items-center py-4 guide_block row_mod">
                <div class="col-md-6 col-12">
                    <h2 class="mb-0 font-active">recreate your first date</h2>
                    <p class="my-4" v-if="$country.is_india">
                        Whether you had your first date in a neighborhood restaurant, diner or coffee shop, spice up the experience, wear an item of clothing identical to what you wore on your first date, and make it unique by adding flowers and decorations. You may order the same food or drink you did years ago, make small talk, and then pop the question with an exquisite proposal ring.
                        <br><br>
                        Andy popped the question to Angelise by setting up a perfect surprise date.
                    </p>
                    <p class="my-4" v-else>Whether you had your first date in a neighborhood restaurant, diner, or coffee shop, spice up the experience, wear an item of clothing identical to what you wore on your first date, and make it unique by adding flowers and decorations. You may order the same food or drink you did years ago, make small talk, and then pop the question with an exquisite proposal ring. <br><br>
                    Andy popped the question to Angelise by setting up a perfect surprise date.</p>
                    <h3 class="mb-4">Andy Galarza & Angelise</h3>
                    <NuxtLink class="radious_four" :to="localePath('/testimonials/andy-angelise')">Read more</NuxtLink>
                </div>
                <div class="col-md-6 col-12">
                    <picture>
                        <source width="577" height="364" type="image/webp" srcset="~/assets/eng-guide/step_five/recreate.webp">
                        <img loading="lazy" width="577" height="364" class="img-fluid radious_eight" src="~/assets/eng-guide/step_five/recreate.jpg" alt="recreate your first date">
                    </picture>
                </div>
            </div>
      
            <div class="row cta_block">
                <div class="col-md-12 col-12 mx-auto px-0 d-flex align-items-center justify-content-center font-active">
                    <NuxtLink :to="localePath('/engagement-ring-guide/complete-the-ring')">
                        Complete the Ring <div class="arrow_eng">
                            <SvgHeaderSvg :type="'left'" /></div> Back
                    </NuxtLink>
                </div>
            </div>   
        </div>
    </section>
</template>

<script setup>
const localePath = useLocalePath()
const { $country } = useNuxtApp()
useFetchMeta( useNuxtApp(), useRuntimeConfig() );
</script>

<style scoped>
.arrow_eng svg.svg-head {
    height: 13px;
    width: 12px;
    margin: 0 10px;
}
.eng_guide_banner {
    position: relative;
}
.eng_guide_upper {
    position: absolute;
    top: 50%;
    left: 20%;
    width: 25%;
    transform: translate(-50%,-50%);
}
 .eng_guide_upper h2 {
    font-size: 16px;
    font-weight: 500;
    text-transform: capitalize;
}
.eng_guide_upper h1 {
    font-size: 32px;
    color: var(--green);
    font-weight: 500;
    text-transform: capitalize;
}
.eng_guide_upper p {
    font-size: 14px;
    font-weight: 500;
    color: #000;
    line-height: 1.8;
}
.eng_guide_flex {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}
.eng_guide_flex a {
    display: inline-block;
    font-size: 14px;
    padding: 1.5% 5%;
    color: #000;
    text-transform: unset;
    font-weight: 400;
    border: 1px solid #000;
}
/* -------cta */
.row.cta_block a {
    display: flex;
    align-items: center;
    color: #000;
    font-size: 18px;
}
.row.cta_block span {
    font-size: 25px;
    margin: 0 15px;
    font-weight: 300;
}
.row.cta_block {
    margin: 4% 0;
}
/* -------cta */
@media(max-width:1350px ){
    .eng_guide_upper{
        width: 50%;
        left: 30%;
    }
}
@media(max-width:1024px ){
    .eng_guide_upper h1 {
        font-size: 32px;
    }
    .eng_guide_banner img {
        height: 45vh;
        object-fit: cover;
        object-position: 100%;
    }
}
@media(max-width:992px ){
    .eng_guide_banner img{
        display: none;
    }
    .eng_guide_upper {
        width: 100%;
        left: 0;
        transform: unset;
        position: relative;
        top: 0;
    }
    .guide_block_banner {
        padding: 0 36px 5% 36px;
        border-bottom: 1px solid #ccc;
    }
     /* -------cta */
     .row.cta_block a {
        font-size: 16px;
    }
    /* -------cta */
}
@media(max-width:767px ){
    .arrow_eng {
        /* font-size: 40px; */
    }
    .eng_guide_upper h1 {
        font-size: 32px;
    }
    .guide_block_banner {
        padding: 0% 18px 8% 18px;
        border-bottom: 1px solid #ccc;
    }
    /* -------cta */
    .row.cta_block a {
        font-size: 14px;
    }
    /* -------cta */
}
/* ---------------- */
.guide_block {
    margin-top: 5%;
}
.guide_block h2 {
    font-size: 32px;
    text-transform: capitalize;
    color: var(--green);
}
.guide_block p {
    font-size: 16px;
    color: #6a6161;
    font-weight: 500;
}
.guide_block p a {
    background: none;
    padding: 0;
    font-size: 16px;
    text-transform: unset;
    color: #6a6161;
    font-weight: 500;
    border: 0;
    text-decoration: underline;
    color: var(--green);
}
.guide_block h3 {
    font-size: 16px;
    font-weight: 600;
    color: var(--green);
}
.guide_block a {
    display: inline-block;
    font-size: 14px;
    padding: 10px 20px;
    color: #000;
    border: 1px solid #000;
    text-transform: uppercase;
    font-weight: 600;
}

@media(max-width: 992px){
    .guide_block h2 {
        font-size: 26px;
    }
}

@media(max-width: 767px){
    .row_mod {
        flex-direction: column-reverse;
    }
    .guide_block h2 {
        font-size: 26px;
        margin-top: 6%;
    }
    .guide_block p {
        margin: 3% 0 !important;
    }
    .guide_block h3 {
        font-size: 16px;
    }
}
</style>
